import axios from 'axios';
import {server} from './server';

const axiosConfig = {
    withCredentials: true
}

export const getLogin = async (username, password) => {
    console.log(`getLogin ${username} ${password}`)
    return await axios.get(`${server}/login/username/${username}/password/${password}`, axiosConfig)
        .then(function (response) {
            // handle success
            console.log(response);
            return response.data;
        });
}

export const getSession = async () => {
    return await axios.get(`${server}/session`, axiosConfig)
        .then(response => response.data);
}

export const userLogout = async () => {
    return await axios.get(`${server}/logout`, axiosConfig)
        .then(response => response.data);
}

export const getInventory = async (showHidden) => {
    const url = (showHidden) ? `${server}/inventory/hidden` : `${server}/inventory`
    return await axios.get(url, axiosConfig)
        .then(r => r.data);
}

export const getInventoryById = async (inventoryId) => {
    return await axios.get(`${server}/inventory/${inventoryId}`, axiosConfig).then(r => r.data);
}

export const getInventoryByProduct = async (productId) => {
    return await axios.get(`${server}/inventory/product/${productId}`, axiosConfig).then(r => r.data);
}

export const getAllProducts = async () => {
    return await axios.get(`${server}/product`, axiosConfig)
        .then(r => r.data);
}

export const getProduct = async (productId) => {
    return await axios.get(`${server}/product/${productId}`, axiosConfig).then(r => r.data[0])
}

export const getProductCategory = async(category) => {
    return await axios.get(`${server}/product/category/${category}`, axiosConfig).then(r => r.data)
}

export const insertProduct = async (name, description, category, type, subtype, options) => {
    return await axios.post(`${server}/product`, {
        name, description, category, type, subtype,
        sku: options.sku,
        vendorId: options.vendorId,
        strain: options.strain,
        brand: options.brand,
        packagedType: options.packagedType,
        bulkSize: options.bulkSize,
    }, axiosConfig);
}

export const updateProduct = async (productId, options) => {
    return await axios.post(`${server}/product/update`, {
        id: productId,
        ...options
    }, axiosConfig);
}

export const insertInventory = async(itemId, quantity, category, options) => {
    return await axios.post(`${server}/inventory/insert`, {
        itemId, quantity, category,
        sku: options.sku,
        unit: options.unit,
        cost: options.cost,
        book: options.book,
        bulkSize: options.bulkSize,
        shipping: options.shipping,
        tariff: options.tariff,
        batchId: options.batchId,
        bulkCost: options.bulkCost,
    }, axiosConfig).then(r => r.data);
}

export const setInventory = async (name, description, quantity, category, type, subtype, options) => {
    return await axios.post(`${server}/inventory`, {
        name, description, quantity, category, type, subtype,
        sku: options.sku,
        vendorId: options.vendorId,
        strain: options.strain,
        cost: options.cost,
        book: options.book,
        shipping: options.shipping,
        tariff: options.tariff,
        brand: options.brand,
        packagedType: options.packagedType,
        bulkSize: options.bulkSize,
        bulkCost: options.bulkCost,
        unit: options.unit
    }, axiosConfig).then(r => r.data);
}

export const updateInventory = async (id, quantity, isSet=false) => {
    return await axios.post(`${server}/inventory/${id}/quantity`, {
        id,
        quantity,
        isSet
    }, axiosConfig);
}

export const updateInventoryHidden = async (id, hidden) => {
    return await axios.post(`${server}/inventory/${id}/hidden`, {
        id, hidden
    }, axiosConfig).then(r => r.data);
}

export const updateInventorySku = async (id, sku) => {
    return await axios.post(`${server}/inventory/${id}/sku`, {
        id, sku
    }, axiosConfig).then(r => r.data);
}

export const updateInventoryCost = async (id, cost) => {
    return await axios.post(`${server}/inventory/${id}/cost`, {
        id, ...cost
    }, axiosConfig).then(r => r.data);
}

export const updateInventoryBook = async (id, book) => {
    return await axios.post(`${server}/inventory/${id}/book`, {
        id, book
    }, axiosConfig).then(r => r.data);
}

export const addInventoryToCart = async (itemId, quantity) => {
    return await axios.post(`${server}/inventory/cart`, {
        itemId,
        quantity
    }, axiosConfig);
}

export const getInventoryLog = async (inventoryId) => {
    return await axios.get(`${server}/inventory/log/${inventoryId}`, axiosConfig).then(r => r.data);
}

export const updateInventoryAlert = async (inventoryId, quantity, enable) => {
    return await axios.post(`${server}/inventory/alert`, {
        id: inventoryId, quantity, enable
    }, axiosConfig).then(r => r.data);
}

export const clearCart = async (immediate) => {
    const url = (immediate) ? `${server}/inventory/cart/delete` : `${server}/inventory/cart/timeout`
    return await axios.get(url, axiosConfig);
}

export const getCart = async (immediate) => {
    return await axios.get(`${server}/inventory/cart`, axiosConfig).then(r => r.data);
}

export const getUsers = async () => {
    return await axios.get(`${server}/users`, axiosConfig)
        .then(r => r.data);
}

export const getUserRates = async () => {
    return await axios.get(`${server}/users/rate`, axiosConfig)
        .then(r => r.data);
}

export const setUserDepartment = async (id, department) => {
    return await axios.get(`${server}/set/user/${id}/department/${department}`, axiosConfig);
}

export const setNewUser = async (username, firstname, lastname, department, password) => {
    return await axios.post(`${server}/user`, {
        username, firstname, lastname, department, password
    }, axiosConfig)
}

export const setUserPassword = async (id, password) => {
    return await axios.get(`${server}/set/user/${id}/password/${password}`, axiosConfig)
}

export const setUserRate = async (id, hourRate) => {
    return await axios.post(`${server}/user/rate`, {id, hourRate}, axiosConfig).then(r => r.data);
}

export const setUserActive = async (id, active) => {
    return await axios.post(`${server}/user/active`, {id, active}, axiosConfig).then(r => r.data);
}

export const getAllBuyers = async () => {
    return await axios.get(`${server}/buyers`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getBuyer = async (buyerId) => {
    return await axios.get(`${server}/buyer/${buyerId}`, axiosConfig).then(r => r.data);
}

export const setNewBuyer = async (firstname, lastname, company, license) => {
    return await axios.post(`${server}/buyer`, {
        firstname, lastname, company, license}, axiosConfig).then(r => r.data);
}

export const getAddressesForBuyer = async (id) => {
    return await axios.get(`${server}/buyer/${id}/address`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getEmailAddressesForBuyer = async (id) => {
    return await axios.get(`${server}/buyer/${id}/email`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getPhoneNumbersForBuyer = async (id) => {
    return await axios.get(`${server}/buyer/${id}/phonenumber`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const setEmailAddressForBuyer = async (buyerId, email, description, primary) => {
    return await axios.post(`${server}/buyer/${buyerId}/email`, {
        id: buyerId, email, description, primary
    }, axiosConfig);
}

export const setPrimaryEmailAddressForBuyer = async (buyerId, emailId) => {
    return await axios.post(`${server}/buyer/${buyerId}/email/primary`, {
        buyerId, emailId
    }, axiosConfig);
}

export const setPhoneNumberForBuyer = async (buyerId, phoneNumber, description, primary=false) => {
    return await axios.post(`${server}/buyer/${buyerId}/phonenumber`, {
        id: buyerId, phoneNumber, description, primary
    }, axiosConfig);
}

export const setPrimaryPhoneNumberForBuyer = async (buyerId, phoneId) => {
    return await axios.post(`${server}/buyer/${buyerId}/phonenumber/primary`, {
        buyerId, phoneId
    }, axiosConfig);
}

export const setAddressForBuyer = async (buyerId, streetAddress, streetAddressLine2, city, state,
    country, postalCode, description, primary=false) => {

    return await axios.post(`${server}/buyer/${buyerId}/address`, {
        id: buyerId, streetAddress, streetAddressLine2, city, state, country, postalCode, description, primary
    }, axiosConfig)
}

export const setPrimaryAddressForBuyer = async (buyerId, addressId) => {
    return await axios.post(`${server}/buyer/${buyerId}/address/primary`, {
        buyerId, addressId
    }, axiosConfig)
}

export const createInvoice = async (buyerId, invoiceItems) => {
    return await axios.post(`${server}/invoice`, {buyerId, invoiceItems}, axiosConfig);
}

export const getAllInvoices = async () => {
    return await axios.get(`${server}/invoice/open`, axiosConfig).then(function (response) {
        return response.data;
    })
}

export const getInvoice = async (invoiceId) => {
    return await axios.get(`${server}/invoice/${invoiceId}`, axiosConfig).then(r => r.data[0]);
}

export const getPaidInvoices = async () => {
    return await axios.get(`${server}/invoice/paid`, axiosConfig).then(function (response) {
        return response.data;
    })
}

export const getCompleteInvoices = async () => {
    return await axios.get(`${server}/invoice/all`, axiosConfig).then(function (response) {
        return response.data;
    })
}

export const getInvoiceLines = async (invoiceId) => {
    return await axios.get(`${server}/invoice/${invoiceId}/lineitems`, axiosConfig).then(r => r.data);
}

export const insertInvoicePayment = async (invoiceId, amount, accountId, notes) => {
    return await axios.post(`${server}/invoice/payment`, {
        invoiceId, amount, accountId, notes
    }, axiosConfig);
}

export const getInvoicePayments = async (invoiceId) => {
    return await axios.get(`${server}/invoice/${invoiceId}/payment`, axiosConfig).then(r => r.data);
}

export const getBankAccounts = async () => {
    return await axios.get(`${server}/bank/account`, axiosConfig).then(r => r.data);
}

export const insertExpense = async (amount, accountId, department, category, notes, vendorId, date) => {
    return await axios.post(`${server}/bank/expense`, {
        amount, accountId, department, category, notes, vendorId, date
    }, axiosConfig).then(r => r.data);
}

export const insertPayment = async (amount, accountId, notes) => {
    return await axios.post(`${server}/bank/transaction/payment`, {
        amount, accountId, notes
    }, axiosConfig).then(r => r.data);
}

export const verifyInvoiceTransactions = async (invoiceId) => {
    return await axios.post(`${server}/bank/invoice/verify`, {
        invoiceId
    }, axiosConfig);
}

export const verifyPayment = async (id) => {
    return await axios.post(`${server}/bank/payment/verify`, {
        id,
    }, axiosConfig);
}

export const insertInvoiceLineItems = async (invoiceId, lineItems) => {
    return await axios.post(`${server}/invoice/${invoiceId}/lineitems`, {
        invoiceId, lineItems
    }, axiosConfig);
}

export const deleteInvoiceLineItem = async (invoiceId, lineId) => {
    return await axios.post(`${server}/invoice/${invoiceId}/lineitem/${lineId}/delete`,
        {}, axiosConfig);
}

export const updateInvoiceLineItemPrice = async (id, linePrice) => {
    return await axios.post(`${server}/invoice/lineitem/update/price`, {
        id, linePrice
    }, axiosConfig);
}

export const updateInvoiceLineItemDiscount = async (id, lineDiscount) => {
    return await axios.post(`${server}/invoice/lineitem/update/discount`, {
        id, lineDiscount
    }, axiosConfig);
}

export const updateInvoiceLineItemPaid = async (id, totalPaid) => {
    return await axios.post(`${server}/invoice/lineitem/update/amountpaid`, {
        id, totalPaid
    }, axiosConfig);
}

export const updateInvoiceState = async (invoiceId, state) => {
    return await axios.post(`${server}/invoice/${invoiceId}/state`, {
        invoiceId, state
    }, axiosConfig);
}

export const getBankBalances = async () => {
    return await axios.get(`${server}/bank/balances`, axiosConfig).then(r => r.data);
}

export const getInvoicesForBank = async (accountId) => {
    return await axios.get(`${server}/bank/account/${accountId}/invoice`, axiosConfig)
        .then(r => r.data);
}

export const insertBankTranfer = async (source, dest, amount) => {
    return await axios.post(`${server}/bank/transfer`, {source, dest, amount}, axiosConfig)
        .then(r => r.data);
}

export const getAllRecordedPayments = async () => {
    return await axios.get(`${server}/payment/recorded`, axiosConfig).then(r => r.data);
}

export const createPurchaseOrder = async (buyerId, dueDate, notes, productList) => {
    return await axios.post(`${server}/purchaseorder`, {buyerId, dueDate, notes, productList}, axiosConfig)
        .then(r => r.data);
}

export const getPurchaseOrders = async (state, exact=false) => {
    return await axios.get(`${server}/purchaseorder/state/${state}/exact/${exact}`, axiosConfig).then(r => r.data);
}

export const getPurchaseOrderLines = async (purchaseId) => {
    return await axios.get(`${server}/purchaseorder/${purchaseId}/lineitems`, axiosConfig).then(r => r.data);
}

export const getPurchaseOrder = async (purchaseId) => {
    return await axios.get(`${server}/purchaseorder/${purchaseId}`, axiosConfig).then(r => r.data[0]);
}

export const insertPurchaseOrderLineItem = async (purchaseId, lineItem) => {
    return await axios.post(`${server}/purchaseorder/${purchaseId}/lineItem`, {purchaseId, lineItem},
        axiosConfig).then(r => r.data);
}

export const deletePurchaseOrderLineItem = async (purchaseId, lineId) => {
    return await axios.post(`${server}/purchaseorder/${purchaseId}/lineItem/${lineId}/delete`, {purchaseId, lineId},
        axiosConfig).then(r => r.data);
}

export const getPurchaseOrderLineItem = async (purchaseId, lineId) => {
    return await axios.get(`${server}/purchaseorder/${purchaseId}/lineItem/${lineId}`, axiosConfig).then(r => r.data[0]);
}

export const updatePurchaseOrderState = async (purchaseId, state) => {
    return await axios.post(`${server}/purchaseorder/${purchaseId}/update/state`, {
        purchaseId, state
    }, axiosConfig)
}

export const getAllPurchaseOrderLines = async (state) => {
    return await axios.get(`${server}/purchaseorder/lineitems/state/${state}`, axiosConfig).then(r => r.data);
}

export const completePurchaseOrderLine = async (purchaseId, lineId, lineItems, productId, quantity, unit, sku, cost, bookQuantity, hours) => {
    return await axios.post(`${server}/purchaseorder/${purchaseId}/lineItem/${lineId}/complete`, {
        purchaseId, lineId, lineItems, productId, quantity, unit, sku, cost, bookQuantity, hours}, axiosConfig);
}

export const updatePurchaseOrderLineState = async (lineId, state) => {
    return await axios.post(`${server}/purchaseorder/lineItem/:lineId/state`, {
        lineId, state
    }, axiosConfig);
}

export const getPurchaseOrderLineCreation = async (lineId) => {
    return await axios.get(`${server}/purchaseorder/lineitem/${lineId}/creation`, axiosConfig).then(r => r.data);
}

export const insertPurchaseOrderTask = async (purchaseId, tasks) => {
    return await axios.post(`${server}/purchaseorder/${purchaseId}/task`, {
        purchaseId, tasks
    }, axiosConfig).then(r => r.data);
}

export const getPurchaseOrderTask = async (purchaseId) => {
    return await axios.get(`${server}/purchaseorder/${purchaseId}/task`, axiosConfig).then(r => r.data);
}

export const insertReturn = async (invoiceId, invoiceLineId, inventoryId, quantity, refundAmount, accountId, notes) => {
    return await axios.post(`${server}/return`, {
        invoiceId, invoiceLineId, inventoryId, quantity, refundAmount, accountId, notes
    }, axiosConfig)
}

export const getAllReturns = async () => {
    return await axios.get(`${server}/return`, axiosConfig).then(r => r.data);
}

export const getReturnsForInvoice = async (invoiceId) => {
    return await axios.get(`${server}/return/invoice/${invoiceId}`, axiosConfig).then(r => r.data);
}

export const getAllBatches = async () => {
    return await axios.get(`${server}/batches`, axiosConfig).then(r => r.data);
}

export const insertBatch = async (name) => {
    return await axios.post(`${server}/batch`, {name}, axiosConfig);
}

export const deleteBatch = async (batchId) => {
    return await axios.get(`${server}/batch/${batchId}/delete`, axiosConfig).then(r=>r.data);
}

export const getAllVendors = async () => {
    return await axios.get(`${server}/vendor`, axiosConfig).then(r => r.data);
}

export const getVendor = async (vendorId) => {
    return await axios.get(`${server}/vendor/${vendorId}`, axiosConfig).then(r => r.data[0]);
}

export const insertVendor = async (company) => {
    return await axios.post(`${server}/vendor`, {company}, axiosConfig).then(r=> r.data);
}

export const setEmailAddressForVendor = async (vendorId, email, description) => {
    return await axios.post(`${server}/vendor/${vendorId}/email`, {
        id: vendorId, email, description
    }, axiosConfig);
}

export const setPhoneNumberForVendor = async (vendorId, phoneNumber, description) => {
    return await axios.post(`${server}/vendor/${vendorId}/phonenumber`, {
        id: vendorId, phoneNumber, description
    }, axiosConfig);
}

export const setAddressForVendor = async (vendorId, streetAddress, streetAddressLine2, city, state,
                                         country, postalCode, description) => {

    return await axios.post(`${server}/vendor/${vendorId}/address`, {
        id: vendorId, streetAddress, streetAddressLine2, city, state, country, postalCode, description
    }, axiosConfig)
}

export const setPrimaryEmailAddressForVendor = async (vendorId, emailId) => {
    return await axios.post(`${server}/vendor/${vendorId}/email/primary`, {
        vendorId, emailId,
    }, axiosConfig);
}

export const setPrimaryPhoneNumberForVendor = async (vendorId, phoneId) => {
    return await axios.post(`${server}/vendor/${vendorId}/phonenumber/primary`, {
        vendorId, phoneId
    }, axiosConfig);
}

export const setPrimaryAddressForVendor = async (vendorId, addressId) => {
    return await axios.post(`${server}/vendor/${vendorId}/address/primary`, {
        vendorId, addressId,
    }, axiosConfig)
}

export const getAddressesForVendor = async (id) => {
    return await axios.get(`${server}/vendor/${id}/address`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getEmailAddressesForVendor = async (id) => {
    return await axios.get(`${server}/vendor/${id}/email`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getPhoneNumbersForVendor = async (id) => {
    return await axios.get(`${server}/vendor/${id}/phonenumber`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getProfitReport = async (startDate, endDate) => {
    return await axios.post(`${server}/report/profit`, {startDate, endDate},
        axiosConfig).then(r => r.data);
}

export const getOwnedTasks = async () => {
    return await axios.get(`${server}/task/own`, axiosConfig).then(r => r.data);
}

export const getAssignedTasks = async () => {
    return await axios.get(`${server}/task/assigned`, axiosConfig).then(r => r.data);
}

export const getTask = async (taskId) => {
    return await axios.get(`${server}/task/${taskId}`, axiosConfig).then(r => r.data[0]);
}

export const getAllTasks = async () => {
    return await axios.get(`${server}/task/all`, axiosConfig).then(r => r.data);
}

export const getTasksByDepartment = async (department) => {
    return await axios.get(`${server}/task/department/${department}`, axiosConfig).then(r => r.data);
}

export const getFollowedTasks = async () => {
    return await axios.get(`${server}/task/follow`, axiosConfig).then(r => r.data);
}

export const getTaskCount = async () => {
    return await axios.get(`${server}/task/count`, axiosConfig).then(r => r.data[0]);
}

export const insertTask = async (title, description, assignedTo, dueDate) => {
    return await axios.post(`${server}/task`, {title, description, assignedTo, dueDate}, axiosConfig)
        .then(r => r.data);

}

export const updateTaskAssignedTo = async (id, assignedTo) => {
    return await axios.post(`${server}/task/${id}/assignedTo`,{id, assignedTo}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskStatus = async (id, status) => {
    return await axios.post(`${server}/task/${id}/status`,{id, status}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskTitle = async (id, title) => {
    return await axios.post(`${server}/task/${id}/title`,{id, title}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskDescription = async (id, description) => {
    return await axios.post(`${server}/task/${id}/description`,{id, description}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskDueDate = async (id, dueDate) => {
    return await axios.post(`${server}/task/${id}/dueDate`, {id, dueDate}, axiosConfig)
        .then(r => r.data);
}

export const getTaskNotes = async (taskId) => {
    return await axios.get(`${server}/task/${taskId}/notes`, axiosConfig).then(r => r.data);
}

export const insertTaskNote = async (taskId, notes) => {
    return await axios.post(`${server}/task/${taskId}/notes`, {taskId, notes}, axiosConfig).then(r => r.data);
}

export const insertTaskFollower = async (taskId, followers) => {
    return await axios.post(`${server}/task/${taskId}/follower`, {taskId, followers}, axiosConfig).then(r => r.data);
}

export const getTaskFollowers = async (taskId) => {
    return await axios.get(`${server}/task/${taskId}/follower`, axiosConfig).then(r => r.data);
}

export const deleteTaskFollower = async (taskId, userId) => {
    return await axios.post(`${server}/task/${taskId}/follower/delete`, {taskId, userId}, axiosConfig)
        .then(r => r.data);
}

export const getLocations = async () => {
    return await axios.get(`${server}/location`, axiosConfig).then(r => r.data);
}

export const insertLocation = async (longitude, latitude) => {
    return await axios.post(`${server}/location`, {longitude, latitude}, axiosConfig).then(r => r.data);
}
